import AppShell from "@/components/layouts/AppShell";

/**
 * DiscoverShell — layout persistente do módulo "Descobrir"
 * (/discover, /venues, /events, /matches).
 *
 * As páginas já aplicam seu próprio `pb-24`, então o shell não reserva espaço
 * extra — apenas a safe-area inferior do dispositivo.
 */
export default function DiscoverShell() {
  return <AppShell reserveBottomSpace={false} />;
}
